import "../scss/main.scss";
import 'slick-carousel';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

$(function(){


    $('#up').on('click', function(){
        $('html, body').animate({scrollTop: 0}, "slow");
        return false;
    });

    $('#down').on('click', function(){
        $('html, body').animate({scrollTop: $('h1').offset().top - $('#masthead').innerHeight()*2}, "slow");
        return false;
    });

    $('#btNav').on('click', function(){
        $(this).toggleClass('open');
        $('.col--navigation-mobile').toggleClass('open');
    });

    $('#btSearch').on('click', function(){
        $('#search').toggleClass('opensearch');
    });

    $('#search--close').on('click', function(){
        $('#search').removeClass('opensearch');
    });

    actionsScroll();
    $(window).on('scroll', function(){    
        actionsScroll();
    });

    // INIT ALL FUNCTIONS
    resize();
    if( $('.bloc--carrousel').length != 0 || $('.bloc--slider').length != 0 || $('.bloc--listing').length != 0) { sliders(); }
    if( $('.accordeon').length != 0) { accordeon(); }
    if( $('.tabs').length != 0){ tabs(); }
    animationScroll();
    variationRadios();
    orderRequest();
    wishlistCta();
    a11yFixes();
    $(window).on('load', a11yFixes);
    // Contenus ajoutés après coup (boutons favoris rendus par React, produits chargés en AJAX, popup) : on rejoue les correctifs
    if( window.MutationObserver ){
        var a11yTimer = null;
        new MutationObserver(function(){
            clearTimeout(a11yTimer);
            a11yTimer = setTimeout(a11yFixes, 300);
        }).observe(document.body, { childList: true, subtree: true });
    }

    // ACTIONS WINDOW
    actionsScroll();
    $(window).on('scroll', function(){    
        actionsScroll();
    });

    $(window).on('resize', function(){
        resize();
    });

    // La hauteur du header change après le premier affichage (chargement du logo et des polices, retour à la ligne
    // de la barre de recherche…) : on replace le contenu et le fil d'Ariane à chaque changement de sa taille.
    $(window).on('load', resize);
    if( document.fonts && document.fonts.ready ){ document.fonts.ready.then(resize); }
    if( window.ResizeObserver && document.getElementById('masthead') ){
        new ResizeObserver(function(){ resize(); }).observe(document.getElementById('masthead'));
    }

    // Popup d'ajout au panier YITH : son contenu est chargé en AJAX, on initialise donc
    // les boutons favoris des produits suggérés (action officielle du plugin de favoris).
    $(document).on('yith_wacp_popup_after_opening yith_wacp_popup_changed', function(){
        if( window.wp && window.wp.hooks ){
            window.wp.hooks.doAction('yith_wcwl_init_add_to_wishlist_components');
        }
    });
});

function resize(){
    var mastheadHeight = document.getElementById('masthead') ? document.getElementById('masthead').getBoundingClientRect().height : 0;
    $('main, #woocommerce-content').css( 'padding-top', mastheadHeight );

    // Fil d'Ariane : le bloc est collé au bas du header (0px), sur toutes les pages et à toutes les tailles d'écran ;
    // l'espace visible au-dessus du texte vient du padding-top du bloc (_header.scss)
    // (le fil d'Ariane est positionné dans le document : on ajoute la barre d'administration si elle est là)
    $('#breadcrumb').css( 'top', ( $('#wpadminbar').length != 0 ? $('#wpadminbar').outerHeight() : 0 ) + mastheadHeight );

    if($('body.admin-bar').length != 0){
        $('#masthead').css('top', $('#wpadminbar').innerHeight());
        if($(window).width() < 587 && $(window).scrollTop() != 0 ){
            $('body.admin-bar #btNav').css('top', ($('#masthead').innerHeight()*0.5 - $('#btNav').innerHeight()*0.5) );
        }else{
            $('body.admin-bar #btNav').css('top', ($('#wpadminbar').innerHeight() + $('#masthead').innerHeight()*0.5 - $('#btNav').innerHeight()*0.5) );
        }
    }
}

function actionsScroll(){
    $('.site-search').removeClass('active');
    $('#search').removeClass('opensearch');

    var scrolled = $(window).scrollTop();

    if(scrolled > 0 ){
        $('body').addClass('scrolling'); 
    } else {
        $('body').removeClass('scrolling');
    }
}

function sliders(){
    $('.bloc--carrousel').not('.slick-initialized').slick({
        autoplay: true,
        autoplaySpeed: 5000,
        respondTo: 'slider',
        responsive: true,
        arrows: true,
        dots: true,
        infinite: true,
        centerPadding: '18px',
        prevArrow: '<span class="slide-prev"><i class="fa-solid fa-chevron-left"></i></span>',
        nextArrow: '<span class="slide-next"><i class="fa-solid fa-angle-right"></i></span>',
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
    });

    $('.bloc--listing .products').not('.slick-initialized').slick({
        autoplay: false,
        autoplaySpeed: 5000,
        respondTo: 'slider',
        responsive: true,
        arrows: true,
        dots: false,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        centerPadding: '18px',
        prevArrow: '<span class="slide-prev"><i class="fa-solid fa-chevron-left"></i></span>',
        nextArrow: '<span class="slide-next"><i class="fa-solid fa-angle-right"></i></span>',
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
        ]
    });

    $('.bloc--introduction .intro').not('.slick-initialized').slick({
        autoplay: false,
        autoplaySpeed: 5000,
        respondTo: 'slider',
        responsive: true,
        arrows: false,
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<span class="slide-prev"><i class="fa-solid fa-chevron-left"></i></span>',
        nextArrow: '<span class="slide-next"><i class="fa-solid fa-angle-right"></i></span>',
    });
}

// Fiche produit variable : boutons radio (configure/variation-swatches.php) synchronisés avec les <select> de WooCommerce.
// Le select reste la source de vérité (WooCommerce s'en sert pour trouver la variation) ; il est simplement masqué.
function variationRadios(){
    $('form.variations_form').each(function(){
        var $form = $(this);
        if( $form.data('spiritRadios') || $form.find('.spirit-swatches').length == 0 ){ return; }
        $form.data('spiritRadios', true).addClass('spirit-radios');

        $form.find('.spirit-swatches').each(function(){
            var $group = $(this);
            var $select = $group.closest('td').find('select').first();
            if( $select.length == 0 ){ return; }

            function sync(){
                var current = $select.val() || '';
                var name = '';
                $group.find('input').each(function(){
                    var value = this.value;
                    // WooCommerce retire du select les choix incompatibles avec les autres attributs déjà choisis.
                    var available = $select.find('option').filter(function(){ return this.value === value; }).length > 0;
                    this.checked = ( current !== '' && value === current );
                    this.disabled = !available;
                    $(this).closest('.spirit-swatch').toggleClass('is-unavailable', !available);
                    if( this.checked ){ name = $(this).next('label').attr('title') || $.trim($(this).next('label').text()); }
                });
                $group.find('.spirit-swatches__current').text(name);
            }

            $group.on('change', 'input', function(){
                $select.val(this.value).trigger('change');
            });
            $select.on('change', sync);
            $form.on('woocommerce_update_variation_values reset_data', sync);
            sync();
        });
    });
}

// Fiche produit « uniquement sur commande » (configure/on-order.php) : dépliage du formulaire de demande,
// préremplissage avec le produit et les options choisis, et affichage selon la variation sélectionnée.
function orderRequest(){
    var $toggle = $('.spirit-order__toggle');
    var $panel = $('.spirit-order__form');
    if( $toggle.length == 0 || $panel.length == 0 ){ return; }

    var $form = $('form.variations_form');

    function summary(){
        var text = $.trim($('h1.product_title').first().text());
        var sku = $.trim($('.product-sku .product-value').first().text());
        if( sku ){ text += ' (réf. ' + sku + ')'; }

        var options = [];
        $form.find('table.variations tr').each(function(){
            var $select = $(this).find('select').first();
            if( $select.val() ){
                options.push( $.trim($(this).find('th.label').text()) + ' : ' + $.trim($select.find('option:selected').text()) );
            }
        });
        return options.length ? text + ' — ' + options.join(', ') : text;
    }

    function fill(){
        $panel.find('input[name="text-1"]').val( summary() );
        // Adresse de la page du produit (le champ masqué reprend la valeur envoyée par le navigateur)
        $panel.find('input[name="hidden-1"]').val( window.location.origin + window.location.pathname );
    }

    function close(){
        $panel.prop('hidden', true);
        $toggle.attr('aria-expanded', 'false');
    }

    $toggle.on('click', function(){
        var open = $panel.prop('hidden');
        $panel.prop('hidden', !open);
        $toggle.attr('aria-expanded', open ? 'true' : 'false');
        if( open ){ fill(); }
    });

    if( $toggle.data('mode') === 'variation' ){
        // Produit variable dont certaines variations seulement sont en rupture : le bouton n'apparaît
        // que pour une variation en rupture.
        $form.on('found_variation', function(e, variation){
            var onOrder = variation && variation.is_in_stock === false;
            $toggle.prop('hidden', !onOrder);
            if( onOrder ){ fill(); } else { close(); }
        });
        $form.on('hide_variation reset_data', function(){
            $toggle.prop('hidden', true);
            close();
        });
    }

    $form.on('change', 'select', fill);
    // Sécurité : dernier remplissage juste avant l'envoi du formulaire
    $panel.on('submit', 'form', fill);
    fill();
}

// Page « Liste de mes favoris » (YITH Wishlist), affichage mobile (configure/on-order.php ne couvre que
// l'affichage ordinateur : sur mobile le plugin charge un modèle différent, sans le point d'ancrage nécessaire
// côté PHP). Ajoute le même bouton « Voir la fiche produit » pour les lignes qui n'en ont pas (rupture de stock).
function wishlistCta(){
    $('.wishlist_table.mobile > li').each(function(){
        var $li = $(this);
        var $info = $li.find('.additional-info-wrapper');
        if( $info.length == 0 || $info.find('.product-add-to-cart').length != 0 ){ return; }

        var href = $li.find('.product-name a').attr('href');
        if( !href ){ return; }

        var $btn = $('<div class="product-add-to-cart"><a class="button">Voir la fiche produit</a></div>');
        $btn.find('a').attr('href', href);

        var $remove = $info.find('.product-remove');
        if( $remove.length != 0 ){ $btn.insertBefore($remove); } else { $info.append($btn); }
    });
}

// Accessibilité : noms accessibles pour les éléments dont le contenu est fourni par des plugins ou des images seules.
// Ne modifie que des attributs (aucun changement visuel).
function a11yFixes(){
    // Boutons favoris YITH (icône seule, rendue par React) : nom + état
    $('button.yith-wcwl-add-to-wishlist-button').each(function(){
        var $b = $(this);
        if( $.trim($b.text()) !== '' && !$b.hasClass('yith-wcwl-add-to-wishlist-button--icon-button') ){ return; }
        var name = $.trim( $b.closest('li.product, .type-product, .ann').find('.woocommerce-loop-product__title, .ann-titre, h2, h3, h4').first().text() );
        var inList = !/outline/.test( $b.find('svg').first().attr('id') || '' );
        var label = ( inList ? 'Retirer des favoris' : 'Ajouter aux favoris' ) + ( name ? ' : ' + name : '' );
        if( $b.attr('aria-label') !== label ){ $b.attr('aria-label', label); }
        $b.attr('aria-pressed', inList ? 'true' : 'false');
        $b.find('svg').attr('aria-hidden', 'true');
    });

    // Liens sans texte (bandeaux image, vignettes produit) : nom déduit de l'adresse de la page ciblée
    $('a[href]').not('[aria-label], [aria-labelledby], [title]').each(function(){
        var $a = $(this);
        if( $.trim($a.text()) !== '' || $a.find('img[alt]').filter(function(){ return $(this).attr('alt') !== ''; }).length != 0 ){ return; }
        var slug = ( $a.attr('href').split('#')[0].split('?')[0].replace(/\/+$/, '').split('/').pop() || '' );
        if( slug === '' || /^(tel|mailto):/.test($a.attr('href')) ){ return; }
        try { slug = decodeURIComponent(slug); } catch(e){}
        slug = slug.replace(/[-_]+/g, ' ');
        $a.attr('aria-label', slug.charAt(0).toUpperCase() + slug.slice(1));
    });

    // Carrousels Slick : le plugin insère des <div> entre <ul> et <li> (liste invalide) : on retire la sémantique de liste
    $('ul.slick-initialized').attr('role', 'presentation').find('li').attr('role', 'presentation');

    // Bouton « Commander ce produit » tant qu'aucune variante n'est choisie : WooCommerce ne pose qu'une classe « disabled »,
    // on l'annonce aussi comme désactivé aux lecteurs d'écran
    $('.single_add_to_cart_button').each(function(){
        var $b = $(this);
        if( $b.hasClass('disabled') ){ $b.attr('aria-disabled', 'true'); } else { $b.removeAttr('aria-disabled'); }
    });

    // Images sans attribut alt (décoratives)
    $('img:not([alt])').attr('alt', '');
}

function tabs(){
    var hauteurMax = 0;
    $('.tab-content').each(function(){
        if( $(this).innerHeight() >= hauteurMax ){
            hauteurMax = $(this).innerHeight();
            $('.tab-content').css('min-height', hauteurMax);
        }
    });

    $('.tabs .tab').on('click', function(e){
        e.preventDefault();

        if( !$(this).parent('li').hasClass('active') ){
            var tab = $(this).attr('data');

            /* On suprime la class active de tous les contenus */
            $('.tab-content').removeClass('active');
            $('.tab-content').hide().delay( 200 );

            /* On supprime la classe pour tous les liens */
            $('.tabs li').removeClass('active');

            /* On ajoute la classe active à l'onglet qui doit être visible */
            $(tab).addClass('active');
            $(tab).show();

            /* On ajoute la classe pour le lien sur lequel l'internaute vient de cliquer */
            $(this).parent('li').addClass('active');

            return false;
        }
    });
}

function accordeon(){
    $('.bloc--accordeon .accordeon--content').hide();

    // On sélectionne tous les items de liste portant la classe "toggleSubMenu"
    // et on remplace l'élément span qu'ils contiennent par un lien :
    $(".accordeon .accordeon--title").on('click', function () {
        // Si le sous-menu était déjà ouvert, on le referme :
        if ($(this).next(".accordeon--content:visible").length != 0) {
            $(this).next(".accordeon--content").slideUp("normal");
            $(this).removeClass('open');
        }
        // Si le sous-menu est caché, on ferme les autres et on l'affiche :
        else {
            $(".accordeon .accordeon--content").slideUp("normal");
            $(".accordeon .accordeon--title").removeClass('open');
            $(this).next(".accordeon--content").slideDown("normal");
            $(this).addClass('open');
        }
        // On empêche le navigateur de suivre le lien :
        return false;
    });
}

function animationScroll(){
    ScrollTrigger.defaults({
        toggleActions: "restart pause resume pause"
    });

    let scrollAnimFade = gsap.utils.toArray('.elem--anim-opacity');
    scrollAnimFade.forEach(item => {
        gsap.from(item, {
            scrollTrigger: {
                trigger: item,
                start: "top 90%",
                end: "top 75%",
                markers: false,
                scrub: true
            },
            opacity: 0,
            duration: 0.5
        });
    });

    if( $('.title--anim').length != 0) {
        let scrollAnimTitle = gsap.utils.toArray('.title--anim');
        scrollAnimTitle.forEach(item => {
            gsap.from(item, {
                scrollTrigger: {
                    trigger: item,
                    start: "top 90%",
                    end: "top 75%",
                    markers: false,
                    scrub: true
                },
                opacity: 0,
                duration: 0.5
            });
        });
    }

    if( $('.elem--anim-top').length != 0) {
        let scrollAnimtop = gsap.utils.toArray('.elem--anim-top');
        scrollAnimtop.forEach(item => {
            gsap.from(item, {
                scrollTrigger: {
                    trigger: item,
                    start: "top 90%",
                    end: "top 75%",
                    markers: false,
                    scrub: true
                },
                opacity: 0,
                y: 90,
                duration: 0.5,
                // Un transform résiduel crée un nouveau repère pour les éléments en position: fixed
                // (ex. badge reCAPTCHA) : on le retire une fois l'animation terminée.
                clearProps: 'transform'
            });
        });
    }

    if( $('.elem--anim-enter').length != 0) {
        gsap.to(".elem--anim-enter", 0.5, { autoAlpha: 1, y: 0, clearProps: 'transform' });
    }
}